import React, { useEffect, useState } from "react";

import { getS3URL } from "../../../_helpers";
import moment from "moment/moment";
import { Loading } from "../../Other/Loading";
import axiosInstance from "../../../axios";

const addedTeachers = [
  {
    name: "Lisa B.Dupree",
    country: "United States",
    date: "06-12-22",
  },
  {
    name: "Kenneth Peter",
    country: "India",
    date: "04-12-22",
  },
  {
    name: "Ismael Cole",
    country: "Iran",
    date: "04-12-22",
  },
  {
    name: "Pamela Elliott",
    country: "South Korea",
    date: "02-12-22",
  },
  {
    name: "Robert Hairston",
    country: "United States",
    date: "26-11-22",
  },
];
const TeacherAdminData = ({ instructor }) => {
  const [teacherData, setTeacherData] = useState([]);
  const [load, setload] = useState(true);
  function fetch() {
    instructor
      ? axiosInstance
          .get("instructor/students")
          .then((res) => {
            setTeacherData(res?.data?.data?.data);
            setload(false);
          })
          .catch((error) => console.log(error))
      : axiosInstance
          .get("user/teacher")
          .then((res) => {
            setTeacherData(res?.data?.data?.data);
            setload(false);
          })
          .catch((error) => console.log(error));
  }

  useEffect(() => {
    fetch();
  }, []);
  return (
    <>
      {load && <Loading />}
      {teacherData.slice(0, 5).map((item, index) => (
        <div className="avator-padding-bottom" key={index}>
          <div className="new-profile-flex">
            <img
              src={
                item?.profileImage
                  ? getS3URL(item.profileImage)
                  : "https://www.w3schools.com/howto/img_avatar2.png"
              }
              className="avatar-profile-image-01"
            />
            <div>
              <p className="profile-data">{item.firstName}</p>
              <p className="profile-data-1">United State</p>
            </div>
          </div>
          <div>
            <p className="data-paragraph-css">
              {moment(item?.createdAt).format("DD-MM-YYYY")}
            </p>
          </div>
        </div>
      ))}
    </>
  );
};

export default TeacherAdminData;
